import { Page } from '../../../components';
import { FieldWalkthroughsDetails } from './field-walkthrough-details';

export const FieldWalkthroughDetailPage = () => {
  return (
    <Page title="Perform Field Walkthrough">
      <FieldWalkthroughsDetails />
    </Page>
  );
};
